/**
 * LanguageFlags — Shared language picker with country code labels
 * Works on APK (no emoji dependency) — uses text codes with color accents
 */
import { useTranslation } from 'react-i18next';

const LANGS = [
  { code: 'de', label: 'DE', color: '#ffcc00' },
  { code: 'en', label: 'GB', color: '#003399' },
  { code: 'pt', label: 'BR', color: '#009c3b' },
  { code: 'tr', label: 'TR', color: '#e30a17' },
  { code: 'pl', label: 'PL', color: '#dc143c' },
  { code: 'uk', label: 'UA', color: '#005bbb' },
  { code: 'ar', label: 'SA', color: '#006c35' },
  { code: 'fr', label: 'FR', color: '#002395' },
  { code: 'it', label: 'IT', color: '#008c45' },
  { code: 'es', label: 'ES', color: '#c60b1e' },
];

export function LanguageFlags({ dark = false, onChange }) {
  const { i18n } = useTranslation();
  const current = i18n.language?.slice(0, 2) || 'de';

  const handleClick = (code) => {
    i18n.changeLanguage(code);
    if (onChange) onChange(code);
  };

  return (
    <div data-testid="language-flags" style={{
      display: 'flex', flexWrap: 'wrap', gap: 6, justifyContent: 'center',
    }}>
      {LANGS.map(({ code, label, color }) => {
        const active = current === code;
        return (
          <button
            key={code}
            type="button"
            data-testid={`lang-flag-${code}`}
            onClick={() => handleClick(code)}
            style={{
              width: 36, height: 28, borderRadius: 6, cursor: 'pointer',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: 11, fontWeight: 700, letterSpacing: '0.02em',
              transition: 'all 0.15s',
              background: active
                ? (dark ? 'rgba(0,212,255,0.2)' : 'rgba(0,120,212,0.12)')
                : (dark ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.04)'),
              border: active
                ? '2px solid #00d4ff'
                : `2px solid ${dark ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.08)'}`,
              color: active
                ? '#00d4ff'
                : (dark ? 'rgba(255,255,255,0.6)' : '#555'),
              borderBottomColor: active ? '#00d4ff' : color,
              borderBottomWidth: 3,
            }}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
}
